import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const getAllExportPacking = createAsyncThunk(
  "ExportSalesOrder/FindAllExportPackingOrder",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/FindAllExportPackingOrder`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Export Packing:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createExportPacking = createAsyncThunk(
  "ExportSalesOrder/InsertExportPackingOrder",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/InsertExportPackingOrder`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Creating Export Packing:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateExportPackingItem = createAsyncThunk(
  "ExportSalesOrder/UpdateExportPackingOrder",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/UpdateExportPackingOrder`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Updating Export Packing:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getExportPackingItemByID = createAsyncThunk(
  "ExportSalesOrder/FindByExportPackingOrder",
  async (ID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/FindByExportPackingOrder`,
        { export_packing_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        id: result?.id,
        export_packing_guid: result?.export_packing_guid,
        export_sales_order_item_id: result?.export_sales_order_item_id,
        item_id: result?.item_id,
        item_name: result?.item_name,
        packing_weight: result?.packing_weight,
        unit_id: result?.unit_id,
        packing_unit_id: result?.packing_unit_id,
        unit_name: result?.unit_name,
        packing_size: result?.packing_size,
        quantity_ctn: result?.quantity_ctn,
        total_weight: result?.total_weight,
        sr_no: result?.sr_no,
        size_c: result?.size_c,
        size_b: result?.size_b,
        size_m: result?.size_m,
        total: result?.total,
        sub_total: result?.sub_total,
        gross_kg: result?.gross_kg,
        net_kg: result?.net_kg,
        gross_weight: result?.gross_weight,
        net_weight: result?.net_weight,
        conversion_unit_for_weight: result?.conversion_unit_for_weight,
        item_options: result?.item_options || [],
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Export Packing Item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllPendingExportSO = createAsyncThunk(
  "ExportSalesOrder/FindAllPendingExportSalesOrder",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/ExportSalesOrder/FindAllPendingExportSalesOrder`
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Pending Export Sales Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
